var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.butShow && _vm.route
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "chat-open", on: { click: _vm.handleOpen } },
            [
              _c("span", { staticClass: "chat-open-text" }, [
                _vm._v(_vm._s(_vm.$i18.language("内部反馈"))),
              ]),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                width: "38%",
                title: _vm.$i18.language("内部反馈"),
                visible: _vm.Dataerrorcorrection,
                "destroy-on-close": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.Dataerrorcorrection = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "formdata",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.formdata,
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("companyDetail.replyEmail"),
                        prop: "emaile",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("companyDetail.enterEmail"),
                        },
                        model: {
                          value: _vm.formdata.emaile,
                          callback: function ($$v) {
                            _vm.$set(_vm.formdata, "emaile", $$v)
                          },
                          expression: "formdata.emaile",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("companyDetail.contactPhone"),
                        prop: "telephone",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("companyDetail.enterPhone"),
                        },
                        model: {
                          value: _vm.formdata.telephone,
                          callback: function ($$v) {
                            _vm.$set(_vm.formdata, "telephone", $$v)
                          },
                          expression: "formdata.telephone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$i18.language("附件:") } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            headers: _vm.headers,
                            action: `/api/help/file/uploadFile`,
                            "on-remove": _vm.handleRemove,
                            "on-success": _vm.handleChange,
                            "before-upload": _vm.beforeUpload,
                            limit: 3,
                            "on-exceed": _vm.handleExceed,
                            multiple: "",
                            "file-list": _vm.formdata.fileList,
                          },
                        },
                        [
                          _c("el-button", { staticClass: "confirm-btn" }, [
                            _vm._v(_vm._s(_vm.$i18.language("点击上传"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("companyDetail.questionDse"),
                        prop: "desc",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          rows: 6,
                          type: "textarea",
                          maxlength: 280,
                          placeholder: _vm.$i18.language(
                            "请简要描述一下当前页面中，对于内容/数据的疑问。最多输入280个字符。"
                          ),
                        },
                        model: {
                          value: _vm.formdata.desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.formdata, "desc", $$v)
                          },
                          expression: "formdata.desc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "sub-confirm-btn",
                      on: {
                        click: function ($event) {
                          _vm.Dataerrorcorrection = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "confirm-btn",
                      on: {
                        click: function ($event) {
                          return _vm.confirmMtji("formdata")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }